import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import { ValidacionesService } from 'src/app/servicios/validaciones.service';
import { ToastrService } from 'ngx-toastr';


enum ID_VERTICALES {
  SMART_RESIDENCE = 19
}

enum ESTADOS_LOGIN {
  LOGIN,
  RECUPERAR_CONTRASENA,
  NUEVA_CONTRASENA
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private router: Router,
    private autenticacionService: AutenticacionService,
    private toastr: ToastrService, 
    private route: ActivatedRoute,
  ) { }

  ESTADOS_LOGIN = ESTADOS_LOGIN;
  estado: ESTADOS_LOGIN = ESTADOS_LOGIN.LOGIN;
  cargando: boolean = false;

  public loginForm: FormGroup = new FormGroup({
    email: new FormControl("celador1elmilagro@tockall.com", [Validators.required, Validators.email]),
    contrasena: new FormControl("admin123", [Validators.required]),
  })

  public recuperarContrasenaForm: FormGroup = new FormGroup({
    email: new FormControl("nicolas.12.aguilar@gmail.com", [Validators.required, Validators.email])
  })

  public nuevaContrasenaForm: FormGroup = new FormGroup({
    contrasena: new FormControl(null, [Validators.required, Validators.email]),
    repeticionContrasena: new FormControl(null, [Validators.required]),
  })

  ngOnInit(): void {
    if(this.router.url.includes("nueva-contrasena")) {
      this.estado = ESTADOS_LOGIN.NUEVA_CONTRASENA;
    }
  }

  onClickLogin() {
    if(!this.loginForm.get("email").valid) {
      this.toastr.warning('Formato del correo invalido');
    } else if(!this.loginForm.get("contrasena").valid) {
      this.toastr.warning('Por favor ingresa una contraseña');
    } else {
      this.cargando = true;
      this.autenticacionService.login(this.loginForm.get('email').value, this.loginForm.get('contrasena').value).subscribe(res => {
        this.cargando = false;
        if(res.ok) {
          localStorage.setItem("data_login", JSON.stringify(res.response.data_login));
        }
        if(res.ok && this.autenticacionService.dataLogin.vertical_id !== ID_VERTICALES.SMART_RESIDENCE) {
          this.toastr.error("Este usuario no es válido para está vertical");
        } else if(res.ok) {
          this.router.navigate(['/']);
        }
      }, err => {
        this.cargando = false;
        this.toastr.error(err.error.message);
      });
    }
  }

  onOlvidasteContrasena() {
    this.estado = ESTADOS_LOGIN.RECUPERAR_CONTRASENA;
  }

  recuperarContrasena() {
    if(!this.recuperarContrasenaForm.get("email").valid) {
      this.toastr.warning('Formato del correo invalido');
    } else {
      this.cargando = true;
      this.autenticacionService.recuperarContrasena(this.recuperarContrasenaForm.get("email").value).subscribe(res => {
        this.cargando = false;
        this.toastr.success("Se ha enviado un correo para recuperar tu contraseña", "Enviado");
      }, err => {
        this.cargando = false;
        this.toastr.error(err.error.message);
      });
    }
  }
  
  cambiarContrasena() {
    const contrasena = this.nuevaContrasenaForm.get("contrasena").value;
    const repeticionContrasena = this.nuevaContrasenaForm.get("repeticionContrasena").value;
    const token = this.route.snapshot.paramMap.get("token");

    if(contrasena !== repeticionContrasena) {
      this.toastr.error("Las contraseñas no coinciden");
    } else if(contrasena === "") {
      this.toastr.error("Los campos están vacios");
    } else {
      this.cargando = true;
      this.autenticacionService.cambiarContrasena(contrasena, token).subscribe(res => {
        this.cargando = false;
        this.toastr.success("Contraseña actualizada satisfactoriamente");
        this.router.navigate(['/login']);
      }, err => {
        this.cargando = false;
        this.toastr.error(err.error.message);
      });
    }
  }

  onRegresarClick() {
    this.estado = ESTADOS_LOGIN.LOGIN;  
  }
}
